<template>
    <v-container class="pa-0 mb-6">
        <v-card class="pa-2 pa-sm-4">
            <div
                class="d-flex justify-space-between mb-2"
                style="line-height: initial"
            >
                <div class="d-flex">
                    <div
                        class="mr-3 d-flex flex-column"
                        style="font-size: 24px"
                    >
                        <fa :icon="statusIcon" class="fa-lg" />
                    </div>
                    <div class="d-flex flex-column mr-1">
                        <strong
                            :class="`oh-data oh-status strong ${getStatus.slug}`"
                            ><TranslatableStringComponent :tstring="{string: `${getStatus.label}`}" /></strong
                        >
                        <p
                            class="mb-0"
                            :style="
                                $vuetify.breakpoint.xsOnly && 'font-size:12px'
                            "
                        >
                            <TranslatableStringComponent :tstring="{string: `${getStatus.desc}`}" />
                        </p>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <span class="oh-label" style="font-size: 12px">
                        <TranslatableStringComponent :tstring="{string: 'total'}" />
                    </span>
                    <span class="oh-data strong" style="font-size: 18px">{{
                        dollars(grandTotal, 2)
                    }}</span>
                </div>
            </div>
            <div
                v-if="webOrder && webOrder.docNo"
                class="px-4 py-0 mb-0"
                style="background-color: #f5f5f5"
            >
                <div>
                    <span class="oh-label mr-4">WEB ORDER #:</span>
                    <span class="oh-data strong">{{ webOrder.docNo }}</span>
                </div>
            </div>
            <div
                v-if="salesOrder && salesOrder.docNo"
                class="px-4 py-0 mb-0"
                style="background-color: #f5f5f5"
            >
                <div>
                    <span class="oh-label mr-4">SALES ORDER #:</span>
                    <span class="oh-data strong">{{ salesOrder.docNo }}</span>
                </div>
            </div>
            <div
                v-if="!salesInvoice && shipper && shipper.docNo"
                class="px-4 py-0 mb-0"
                style="background-color: #f5f5f5"
            >
                <div>
                    <span class="oh-label mr-4">SHIPPER #:</span>
                    <span class="oh-data strong">{{ shipper.docNo }}</span>
                </div>
            </div>
            <div
                v-if="salesInvoice && salesInvoice.docNo"
                class="px-4 py-0 mb-0"
                style="background-color: #f5f5f5"
            >
                <div>
                    <span class="oh-label mr-4">INVOICE #: </span
                    ><span class="oh-data strong">{{
                        salesInvoice.docNo
                    }}</span>
                </div>
            </div>
            <div
                v-ripple
                class="px-2 px-sm-4 py-2 d-flex justify-space-between mb-1 order-details-content"
                @click="redirect()"
            >
                <div>
                    <div v-if="item && item.shippingPoNumber">
                        <span class="oh-label mr-4">PO #:</span
                        ><span :class="`oh-data strong`">{{
                            item.shippingPoNumber
                        }}</span>
                    </div>
                    <div v-if="showTrackButton">
                        <span class="oh-label mr-4">
                            <TranslatableStringComponent :tstring="{string: 'placedOn'}" />: 
                        </span
                        ><span class="oh-data strong">{{
                            convertToReadabledate(
                                (webOrder && webOrder.transactionDate) ||
                                    (salesOrder && salesOrder.transactionDate)
                            )
                        }}</span>
                    </div>
                    <div>
                        <span class="oh-label mr-4">{{ shipDateLabel }}: </span
                        ><span class="oh-data strong">{{ shipDate }}</span>
                    </div>
                    <div v-show="item.isShipItComplete">
                        <span class="oh-label mr-4">
                            <TranslatableStringComponent :tstring="{string: 'allowBackorders'}" />:
                        </span
                        ><span class="oh-data strong">
                            <TranslatableStringComponent :tstring="{string: 'no'}" />
                        </span>
                    </div>
                </div>

                <div class="d-flex flex-column pa-2">
                    <v-btn icon style="margin: 0 auto">
                        <fa
                            :icon="['fal', 'chevron-circle-right']"
                            class="fa-lg"
                            style="color: #999ba3; font-size: 28px"
                        />
                    </v-btn>
                    <v-btn
                        v-if="$vuetify.breakpoint.mdAndUp"
                        text
                        class="pa-0"
                        style="
                            font-size: 12px;
                            text-transform: lowercase;
                            height: auto;
                        "
                        >
                        <TranslatableStringComponent :tstring="{string: 'viewDetails'}" />
                    </v-btn
                    >
                </div>
            </div>
            <div class="pt-2">
                <v-container class="pa-0 px-3">
                    <v-row>
                        <v-col
                            v-if="showTrackButton"
                            :cols="
                                salesInvoice
                                    ? $vuetify.breakpoint.smAndDown
                                        ? '12'
                                        : '4'
                                    : '6'
                            "
                            :class="{
                                'pa-0':
                                    !$vuetify.breakpoint.smAndDown ||
                                    !salesInvoice,
                                'pr-1':
                                    !$vuetify.breakpoint.smAndDown ||
                                    !salesInvoice,
                            }"
                            ><v-btn
                                outlined
                                color="primary"
                                block
                                @click="orderTrackingDialog = true"
                            >
                                <div>
                                    <TranslatableStringComponent :tstring="{string: 'track'}" />
                                    <fa
                                        :icon="['fal', 'map-marker-alt']"
                                        class="fa-lg ml-2"
                                    />
                                </div> </v-btn
                        ></v-col>
                        <v-col
                            v-if="salesInvoice"
                            :cols="
                                showTrackButton &&
                                !$vuetify.breakpoint.smAndDown
                                    ? '4'
                                    : !showTrackButton &&
                                      !$vuetify.breakpoint.smAndDow
                                    ? '6'
                                    : '12'
                            "
                            :class="{
                                'pa-0': !$vuetify.breakpoint.smAndDown,
                                'pr-1': !$vuetify.breakpoint.smAndDown,
                                'py-0': $vuetify.breakpoint.smAndDown,
                            }"
                            ><v-btn
                                outlined
                                color="primary"
                                block
                                @click="$refs.myChild.handleDialog()"
                            >
                                <div>
                                    <TranslatableStringComponent :tstring="{string: 'viewPrintInvoice'}" />
                                    <fa
                                        :icon="['fal', 'download']"
                                        class="fa-lg ml-2"
                                    />
                                </div> </v-btn
                        ></v-col>
                        <v-col
                            :cols="
                                showTrackButton
                                    ? salesInvoice
                                        ? $vuetify.breakpoint.smAndDown
                                            ? '12'
                                            : '4'
                                        : '6'
                                    : '6'
                            "
                            :class="{
                                'pa-0':
                                    !$vuetify.breakpoint.smAndDown ||
                                    !salesInvoice,
                                'pl-1':
                                    !$vuetify.breakpoint.smAndDown ||
                                    !salesInvoice,
                            }"
                        >
                            <v-btn
                                outlined
                                color="primary"
                                block
                                :to="
                                    getStaticLocalePath({
                                        type: 'account',
                                        slugName: 'support',
                                    })
                                "
                                ><div>
                                    <TranslatableStringComponent :tstring="{string: 'support'}" />
                                    <fa
                                        :icon="['fal', 'life-ring']"
                                        class="fa-lg ml-2"
                                    /></div></v-btn
                        ></v-col>
                    </v-row>
                </v-container>
            </div>
        </v-card>
        <OrderPdfModal ref="myChild" :order="item" />
        <v-dialog
            v-if="$vuetify.breakpoint.mdAndUp"
            v-model="orderTrackingDialog"
            max-width="480"
        >
            <OrderTrackingCard
                :order="order"
                :sales-order="salesOrder"
                :web-order="webOrder"
                :shipper="shipper"
                :sales-invoice="salesInvoice"
                @closeDialog="closeDialog($event)"
            />
        </v-dialog>
        <v-bottom-sheet v-else v-model="orderTrackingDialog">
            <v-sheet height="auto" scrollable>
                <OrderTrackingCard
                    :order="order"
                    :sales-order="salesOrder"
                    :web-order="webOrder"
                    :shipper="shipper"
                    :sales-invoice="salesInvoice"
                    @closeDialog="closeDialog($event)"
                />
            </v-sheet>
        </v-bottom-sheet>
    </v-container>
</template>
<script>
import { mapState } from 'vuex'

import handleAuth from '~/mixins/handleAuth'
import handleSnackbar from '~/mixins/handleSnackbar'
import calcTrackingURL from '~/util/calcTrackingURL'
import OrderTrackingCard from '~/components/OrderTrackingCard'
import OrderPdfModal from '~/components/OrderPdfModal.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'OrderHistoryCardErp',
    components: {
        OrderTrackingCard,
        OrderPdfModal,
        TranslatableStringComponent,
    },
    mixins: [handleSnackbar, handleAuth],
    props: {
        order: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            orderTrackingDialog: false,
        }
    },
    computed: {
        // ...mapState('orderHistoryErp', ['orders']),
        statusIcon() {
            if (this.item.workFlowStatus === 'Customer contact required') {
                return ['fal', 'shipping-fast']
            } else if (this.item.docType === 'Shipper') {
                return ['fas', 'box']
            } else if (this.item.docType === 'Sales Invoice') {
                return ['fal', 'shipping-fast']
            } else if (this.item.docType === 'Sales Order') {
                return ['fas', 'box-open']
            } else {
                return ['fal', 'box-open']
            }
        },
        salesInvoice() {
            return this.order.docType === 'Sales Invoice' ? this.order : null
        },
        shipper() {
            if (this.order.docType === 'Sales Invoice')
                return this.order.HistoryConvertedFrom
            else if (this.order.docType === 'Shipper') return this.order
            else return null
        },
        salesOrder() {
            if (this.order.docType === 'Sales Invoice')
                return this.order?.HistoryConvertedFrom?.HistoryConvertedFrom
            else if (this.order.docType === 'Shipper')
                return this.order.HistoryConvertedFrom
            else if (this.order.docType === 'Sales Order') return this.order
            else return null
        },
        webOrder() {
            if (
                this.order.docType === 'Sales Invoice' &&
                !this.order.isBackorder
            )
                return this.order?.HistoryConvertedFrom?.HistoryConvertedFrom
                    ?.HistoryConvertedFrom
            else if (
                this.order.docType === 'Shipper' &&
                !this.order.isBackorder
            )
                return this.order.HistoryConvertedFrom.HistoryConvertedFrom
            else if (
                this.order.docType === 'Sales Order' &&
                !this.order.isBackorder
            )
                return this.order.HistoryConvertedFrom
            else if (this.order.docType === 'Web Order') return this.order
            else return null
        },
        item() {
            return this.order
        },
        getStatus() {
            if (this.item.workFlowStatus === 'Customer contact required') {
                return {
                    label: 'contactSupport',
                    slug: 'contact',
                    desc: 'orderHistoryStatusMessageContact',
                }
            }
            if (this.item.docType === 'Sales Invoice') {
                return {
                    label: 'shipped',
                    slug: 'shipped',
                    desc: 'orderHistoryStatusMessageShipped',
                }
            } else if (this.item.docType === 'Shipper') {
                return {
                    label: 'packed',
                    slug: 'packed',
                    desc: 'orderHistoryStatusMessagePacked',
                }
            } else if (this.item.docType === 'Sales Order') {
                return {
                    label: 'processing',
                    slug: 'processing',
                    desc: 'orderHistoryStatusMessageProcessing',
                }
            } else if (this.item.docType === 'Web Order') {
                return {
                    label: 'pending',
                    slug: 'pending',
                    desc: 'orderHistoryStatusMessagePending',
                }
            } else {
                return { label: 'N/A', slug: '' }
            }
        },
        shippingAccountNumber() {
            return this.item.shippingAccountNumber
        },
        grandTotal() {
            return parseFloat(this.item.total)
        },
        shipDate() {
            return this.item.docType === 'Sales Order' &&
                this.item.state === 'Pending' &&
                // && this.item.isBackorder
                this.item.mfgBoPromise
                ? this.item.mfgBoPromise.match(
                      /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/
                  )
                    ? this.item.mfgBoPromise
                    : 'Please call Customer First for details 724.775.7926'
                : this.convertToReadabledate(this.item.shippingDate)
        },
        shipDateLabel() {
            return this.item.docType === 'Sales Order' &&
                this.item.state === 'Pending' &&
                // this.item.isBackorder &&
                this.item.mfgBoPromise
                ? 'BACKORDER DATE'
                : 'SHIP DATE'
        },
        showTrackButton() {
            const transactionDate = new Date(this.item.transactionDate)
            const importDate = new Date(2021, 10, 10)
            return !(
                transactionDate.getTime() < importDate.getTime() &&
                this.item.uoid === this.item.id
            )
        },
    },

    methods: {
        redirect() {
            let query
            if (this.item.isBackorder)
                query = { orderNo: this.item.uoid, boid: this.item.boid }
            else query = { orderNo: this.item.uoid }
            this.routerPush({
                type: 'page',
                slugName: 'order-details',
                query,
            })
        },
        calcStrong(str) {
            return str === 'N/A' ? '' : ' strong'
        },
        closeDialog(event) {
            this.orderTrackingDialog = event
        },
        convertToReadabledate(isoDate) {
            return isoDate
                ? new Intl.DateTimeFormat('en-US').format(new Date(isoDate))
                : ''
        },
    },
}
</script>
<style lang="scss" scoped>
.oh-data {
    &.oh-status {
        &.shipped {
            color: $success;
        }
        &.processing {
            color: $warning;
        }
        &.pending,
        &.contact {
            color: $error;
        }
    }
    &.strong {
        font-weight: bold;
    }
}

.order-details-content {
    cursor: pointer;
    &:hover {
        background-color: #eaeaeb;
    }
}
</style>
